<template>
    
    <spinner v-if="!loaded" ></spinner>

    <div class="users-template template-page" v-else-if="loaded" > 
        <!--
        <b-input-group>
            <b-form-input v-model="filter" placeholder="Type to Search" class="search-input" />
            <font-awesome-icon icon="times-circle" @click="filter = ''" class="reset-filter" v-bind:class="{ 'd-none' : !filter }" >Clear</font-awesome-icon>
        </b-input-group>
        
        <vue-good-table
            :columns="columns"
            :rows="rows"
            :search-options="{ enabled: true, externalQuery: filter }"
            :pagination-options="{ enabled: true }"
            :selectOptions="{
                enabled: false,
                selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
              }"
             >
        </vue-good-table>
        -->
        <leadOrders v-if="rows" :data="rows" ></leadOrders>
                
    </div>
</template>

<script>
    
import tagsComponent from '../../components/tags.vue' 
import leadOrders from '../../components/leadOrders.vue' 
import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import moment from 'moment'
import helper from '@/helpers/helpers.js';

export default{
    name: "LeadOrders",
    components:{
        tagsComponent,
        leadOrders
    },
    props: {
        ID: { 
            type: [Number, String],
        }
    },
    data () {
        return {
            filter: '',
            rows: [],
            loaded: false,
        }
    },
    beforeCreate: function (){
       // this.$store.dispatch(GET_USERS);
    },
    mounted: function(){
        this.get_data();
        
    },
    computed: {
    },
    methods: {
        get_data(){
          
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin, this.passed_organizationID )
            
            const db = firebase.firestore();
            var ref = db.collection('organizations/'+orgID+'/orders').where('leadID', '==', this.ID ).orderBy('datetime', 'desc');

            return ref.get()
                .then((snapshot) => {
                    let results = [];
                    return Promise.all(
                        snapshot.docs.map(doc => {  
                                let item = {};                
                                item = doc.data(); // will have 'todo.title'
                                item.id = doc.id;
                                results.push( item )
                                //console.log(item)
                                
                                this.rows = results
                                
                            
                                return results;
                        })
                    )
                    .then(results => {                        
                        //return results;   
                        this.loaded = true;
                        this.calculate_CLTV( this.rows );
                    })

                })
            
        },
        calculate_CLTV( data ){
            
            let TOTAL_REVENUE = 0;
            let NUMBER_OF_PURCHASES = 0;
            data.forEach((order)=>{
                if( order.status != 'refunded' && order.status != 'failed' ){
                    TOTAL_REVENUE += parseFloat(order.price)
                    NUMBER_OF_PURCHASES++
                }
            })
            
            let AVG_PURCHASE_VALUE = parseFloat( TOTAL_REVENUE ) / parseFloat( NUMBER_OF_PURCHASES )
            
            let CUSTOMER_LIFESPAN = (( data[0].datetime - data[ data.length - 1 ].datetime ) / ( 60*60*24 )).toFixed(2) // days
            
            let LTV = AVG_PURCHASE_VALUE * ( CUSTOMER_LIFESPAN / 365 )

            console.log(LTV)
            
            
        }
    },
    computed:{
        getOrganizationID(){
            return this.$store.getters.getOrganizationID
        },
    }
}
</script>

<style >

</style>


// WEBPACK FOOTER //
// src/templates/leads/Orders.vue